export const defaultTemplate = require('../templates/index.mustache');
export const searchDisabled = require('../templates/searchDisabled.mustache');
export const layoutTemplate = require('../templates/layout.mustache');
export const dependenciesTemplate = require('../templates/dependency.mustache');
export const traceTemplate = require('../templates/trace.mustache');
export const traceViewerTemplate = require('../templates/traceViewer.mustache');



// WEBPACK FOOTER //
// ./js/templates.js